import Base from './Base';

export default class orderTrackingStatus extends Base {
  value = '';
  label = '';

  constructor(props) {
    super();
    this.clone(props);
  }
}
